// CustomizedCareSection.js
import React from 'react';

const CustomizedCareSection = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
          In-Home Aged Care
        </p>
        <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
          Customised In-Home Aged Care in Queensland
        </h2>

        <div className="space-y-4 text-muted text-base leading-relaxed">
          <p>
            At Wei Care, we know that every person we support is different. That is why we build a personalised in-home care plan around each individual's needs, goals, and preferences. Whether you need a few hours of help a week or around-the-clock support, you can feel confident that you or your loved one will be cared for with warmth and respect. Because needs change over time, we offer a wide range of in-home care services and flexible scheduling, so we can respond quickly and update a care plan whenever it is needed. We also believe that clear, open communication is at the heart of good care.
          </p>

          <p>
            Our supervisors stay in regular contact with the people we support and our carers, so information is shared accurately and on time. Every Wei Care carer is well trained, suitably qualified, and screened before they join our team. Alongside a carer who genuinely cares, you can take comfort in knowing support and guidance are available when you need them.
          </p>

          <p className="text-ink font-medium">
            Delivered when and where you need them, our dependable Home Care Services include the following:
          </p>
        </div>
      </div>
    </section>
  );
};

export default CustomizedCareSection;
